import { lazy } from 'react';

export const CourseOverviewLegacyPage = lazy(() => import('./CourseOverviewLegacyPage'));
